module.exports = __webpack_public_path__ + "img/cd-saptamana-patimilor.237b84a9.jpg";